import {
  useContext,
  createContext,
} from "react"

/*
 * this context is provided to children of the select element so that
 * they know when they are currently selected
 */
export interface DropdownSelectContextValue {
  currentValue: number | string;
}

type ContextType = DropdownSelectContextValue | null
export const DropdownSelectContext = createContext<ContextType>(null)

export function useDropdownSelectContext() {
  const context = useContext(DropdownSelectContext)

  if (context === null) {
    throw new Error("Dropdown components must be wrapped in <DropdownSelectContext />")
  }

  return context
}
